import { ref } from "vue";
import { TicketCheckRequest, TicketCheckResponse, TicketCheckWager } from "../../model/ticket-check/ticket-check";
import { usePastDraws } from "./use-past-draws";
import { useWagerBoardStore } from "../stores/use-wager-board-store";
import { usePpWagerDurationStore } from "../stores/use-wager-duration-store";
import { fetchTicketCheckResult } from "@/lotteries/services/wincheck/api";
import { usePpWagerConfiguration } from "./use-wager-configuration";
import { showAlert } from "@sazka/design-system/src/modal-alert/mount-alert";
import { Loader } from "@sazka/design-system/src/loader/loader";
import { useQuestionnairesOnTicketCheck } from "../../../../../../../libs/shared-components/questionnaires/use-questionnaires";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { LotteryUtils } from "@sazka/lotteries/js/utils/lottery-utils";
import { PastDraw } from "@/lotteries/model/draw-info/past-draw";

const isTicketCheck = ref(false);
const ticketCheckResult = ref<TicketCheckResponse | null>(null);

const setTicketCheck = (value: boolean) => {
    isTicketCheck.value = value;
};

const getTicketCheckResult = async () => {
    try {
        Loader.show();
        const wagerStore = useWagerBoardStore();
        const durationStore = usePpWagerDurationStore();
        const config = usePpWagerConfiguration().config;
        let draw: PastDraw;

        if (LotteryUtils.isQuickLottery(config.lottery)) {
            draw = {
                id: wagerStore.pastDrawId,
                name: null,
            };
        } else {
            const { pastDraws } = usePastDraws();
            draw = pastDraws.value.find((x) => x.id === wagerStore.pastDrawId);
        }

        const wager: TicketCheckWager = {
            boards: wagerStore.isSystem ? [wagerStore.systemBoard] : wagerStore.getBoardsForCheckout,
            isSystem: wagerStore.isSystem,
            addonNumbers: wagerStore.addonNumbers ?? [],
            multiplier: wagerStore.multiplier,
            stakes: config.lottery === Lottery.kasicka && !wagerStore.isSystem ? [] : wagerStore.wagerStakes,
            duration: durationStore.ticketCheckDuration,
        };

        const request: TicketCheckRequest = {
            draw,
            wager,
        };

        ticketCheckResult.value = await fetchTicketCheckResult(config.lottery, request);
        setTimeout(async () => await useQuestionnairesOnTicketCheck(config.lottery), 3000);
    } catch (e) {
        showAlert({
            title: "Nepodařilo se načíst výsledky sázky",
            subText: "Zkuste to prosím později",
        });
    } finally {
        Loader.hide();
    }
};

export const usePpTicketCheck = () => {
    return {
        isTicketCheck,
        ticketCheckResult,
        setTicketCheck,
        getTicketCheckResult,
    };
};
